import React from "react";
import {
  Box,
  Paper,
  Typography,
  Button,
  Alert,
  Divider,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { generateFilename } from "../../utils/encryption";

const DecryptedOutput = ({ decryptedData, fileFormat, onDownload }) => {
  if (!decryptedData) return null;

  const filename = generateFilename("decoded_file", fileFormat.toLowerCase());

  return (
    <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
      <Typography variant="h5" gutterBottom>
        Decrypted File
      </Typography>

      <Alert severity="success" sx={{ mb: 3 }}>
        Decryption successful! Your file is ready to download.
      </Alert>

      <Divider sx={{ my: 2 }} />
      
      <Typography variant="h6" gutterBottom>
        Preview
      </Typography>

      <Box 
        sx={{ 
          my: 2, 
          maxHeight: '400px', 
          overflow: 'hidden',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          border: '1px solid #e0e0e0',
          borderRadius: 1,
          p: 1
        }}
      >
        <img
          src={decryptedData}
          alt="Decrypted"
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
            objectFit: "contain",
          }}
        />
      </Box>

      <Box sx={{ mt: 3, textAlign: 'center' }}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          startIcon={<DownloadIcon />}
          onClick={onDownload}
        >
          Download Decrypted File
        </Button>
        <Typography variant="caption" display="block" sx={{ mt: 1 }}>
          File will be saved as: {filename}
        </Typography>
      </Box>
    </Paper>
  );
};

export default DecryptedOutput;